import React, { useEffect, useRef, useState } from 'react'

import { getEvents } from "../Service/Api";
const Events = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const datas1 = await getEvents();
        const datas = datas1.filter((item) => item.category === "Events");
      setData(datas);
    };
    getData();
  }, []);
  const marqueeRef = useRef(null);
  const handleMouseOver = () => {
    marqueeRef.current.stop();
  };
  const handleMouseOut = () => {
    marqueeRef.current.start();
  };
  return (
    <>
      <div className='highlight'>
        <p>Notice</p>
        <marquee ref={marqueeRef} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
          {data.length > 0 && data.map((item, index) => (<p key={index}>{item.title}</p>))}
        </marquee>
      </div>
    </>
  )
}
export default Events